<template>
  <pt-lab-product class="pt-lab-product__withData" :methodList="methodList"></pt-lab-product>
</template>

<script>
import PtLabProduct from './index'
export default {
  name: 'pt-lab-product__withData',
  components: {
    'pt-lab-product': PtLabProduct
  },
  data () {
    return {
      methodList: []
    }
  },
  methods: {
    getMethodList () {
      this.$store.dispatch('getMethodList', { pageable: { page: 0, size: 99999, sort: ['createdDate,asc'] } }).then(res => {
        this.methodList = res.data.map(e => {
          return {
            label: e.name,
            value: e.id
          }
        })
      })
    }
  },
  created () {
    this.getMethodList()
  }
}
</script>
